import React from 'react';
import { useGoogleMapsReady } from './GoogleMapsProvider';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default function GoogleMapsGate({ children, loadingMessage = 'Indlæser kort...' }) {
  const { isLoaded, loadError } = useGoogleMapsReady();

  if (loadError) {
    return (
      <LoadingSpinner
        message="Kortet kunne ikke indlæses"
        subtitle="Prøv at genindlæse siden"
        size="large"
        fill
      />
    );
  }

  if (!isLoaded) {
    return (
      <LoadingSpinner message={loadingMessage} eyebrow="Kort" size="large" overlay />
    );
  }

  return children;
}
